import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { theme } from 'utils/style/theme';
/**
 * * 작은 기본 모달
 */

interface IProps {
  children?: JSX.Element[] | JSX.Element;
  style?: React.CSSProperties;
  width?: string | number;
  title: string;
  visible?: boolean;
  footer?: null | JSX.Element[] | JSX.Element;
  onCancel: (e: any) => void;
  top?: string;
}
const SmallModal = ({
  children,
  title,
  onCancel,
  visible,
  style,
  width,
  footer,
  top,
}: IProps) => {
  return (
    <DesignModal
      visible={visible}
      title={title}
      onCancel={onCancel}
      footer={footer}
      style={style}
      width={width}
      top={top}
    >
      {children}
    </DesignModal>
  );
};

export default SmallModal;

SmallModal.defaultProps = {
  footer: null,
};

const DesignModal = styled(Modal)<IProps>`
  width: ${(props) => (props.width ? props.width : '')} !important;
  top: ${(props) => (props.top ? props.top : '')};

  .ant-form-item-label > label {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${theme.colors.black};
    margin-left: 0.2rem;
    width: 7.5rem;
    &::after {
      content: '';
    }
  }
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 0.6rem;
    background-color: ${theme.colors.gray_1};
  }

  .ant-modal-title {
    font-weight: 800;
    font-size: 1.25rem;
    color: ${theme.colors.blueText};
    margin: 0.5rem 0 0 0;
  }
  .ant-modal-body {
    padding: 0 0.5rem 0.5rem 0.5rem;
    max-height: 52rem;
    overflow: auto;
  }
  .ant-modal-footer {
    padding: 0.7rem 1.5rem 0.7rem 1rem;
  }
  .submit_button_wrap {
    text-align: center;
  }
  .dropzone {
    width: 100%;
  }
`;
